module.exports = __webpack_public_path__ + "static/media/robot_smile.138a2c45.png";